module.exports = __webpack_public_path__ + "static/bg-c4804514988012d8259030a23d023a6c.png";